import { Typography } from "@mui/material";
import { getReminderTimeLabel } from "../serviceFlow/settings/clientCommunication/selectReminderTime";

export const CancellationPolicy = ({
  lateCancellationHours,
  noShowFeeValue,
}: {
  lateCancellationHours?: number;
  noShowFeeValue?: number;
}) => (
  <Typography
    variant="labelDefault"
    sx={{
      color: "secondary.main",
      mt: 1,
    }}
  >
    {`Please reschedule or cancel${
      lateCancellationHours
        ? ` at least ${getReminderTimeLabel(lateCancellationHours)}`
        : ""
    } before your appointment to avoid a cancellation fee${
      noShowFeeValue ? ` of $${noShowFeeValue}` : ""
    }. In the event of an emergency, contact us directly. Your card will be held in case of late cancellation and for future purchases. It will not be charged now.`}
  </Typography>
);
